import { render, staticRenderFns } from "./secret-image.vue?vue&type=template&id=641a4d03&"
import script from "./secret-image.vue?vue&type=script&lang=ts&"
export * from "./secret-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports